import axios from 'axios'
import url from './Url'

class aplications extends url {

    constructor() {
        super();
    }

    getVehicleBrands = () => {
        //console.log(this.urlMaster) 

        return axios.get(`${this.url()}/vehicleBrands`)
            .then(brands => {
                return brands.data;
            })
            .catch(err => {
                console.error("Erro na requisição:", err);
                throw err;
            });
    }

    getAplications = (codCronos) => {

        return axios.post(`${this.url()}/vehiclesAplication`, { codCronos })
            .then(applicationsResults => {


                const productsDatasAdditional = {
                    distributors: applicationsResults.data?.product1?.distributors,
                    specifications: applicationsResults.data?.product1?.specifications,
                    vehicles: applicationsResults.data?.product1?.vehicles,
                    crossReference: applicationsResults.data?.product1?.crossReferences
                }

                return productsDatasAdditional;
            })
            .catch(err => {
                console.error("Erro na requisição:", err);
                throw err;
            });
    };



    /*         ANTIGO           */

    getCrossReference = (array) => {
        return axios.post(`${this.url()}/product-cross`, { array })
            .then(crossReference => {
                return crossReference.data;
            })
            .catch(err => {
                console.error("Erro na requisição:", err);
                throw err;
            });
    };

    getProduct = (params, nomePeca, montadora, fabricante) => {
        console.log(nomePeca)
        return axios.get(`${this.url()}/product/${params}?nomePeca=${nomePeca}&montadora=${montadora}&fabricante=${fabricante}`)
            .then(products => {
                return products
            })
            .catch(err => {
                return err
            });

    };

    getAllMontadoras = () => {
        return axios.get(`${this.url()}/montadora`)
            .then(montadoras => {
                return montadoras
            })
            .catch(err => {
                return err
            });
    };

    getAllFabricantes = () => {
        return axios.get(`${this.url()}/fabricantes`)
            .then(fabricantes => {

                return fabricantes
            })
            .catch(err => {
                return err
            });
    };
}

export default aplications;